import React from 'react';
import UserInfo from './UserInfo';
import ActionPanel from './ActionPanel';

export default class LeftPanel extends React.Component {
	render() {
		return (
			<aside className="aside">
				<div className="aside-sidebar">
					<UserInfo />
					<ActionPanel />
				</div>
			</aside>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/home/LeftPanel.js